var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M10.6666 1.6001V3.73343H6.9333C4.29497 3.73343 2.1333 5.8951 2.1333 8.53343C2.13333 8.67622 2.16202 8.81756 2.21768 8.94906C2.21768 8.9494 2.21768 8.94975 2.21768 8.9501C2.44082 11.3857 4.44241 13.3334 6.9333 13.3334H8.5333C8.67465 13.3354 8.81498 13.3093 8.94615 13.2566C9.07731 13.2039 9.1967 13.1256 9.29736 13.0264C9.39802 12.9272 9.47795 12.8089 9.53251 12.6785C9.58706 12.5481 9.61516 12.4081 9.61516 12.2668C9.61516 12.1254 9.58706 11.9855 9.53251 11.855C9.47795 11.7246 9.39802 11.6064 9.29736 11.5071C9.1967 11.4079 9.07731 11.3296 8.94615 11.2769C8.81498 11.2242 8.67465 11.1981 8.5333 11.2001H6.9333C5.4479 11.2001 4.26663 10.0188 4.26663 8.53343C4.26663 7.04803 5.4479 5.86676 6.9333 5.86676H10.6666V8.0001L13.8666 4.8001L10.6666 1.6001Z",
          fill: "CurrentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }